module.exports = __webpack_public_path__ + "7d18cec2b1531a99b4848a5dde1453d3.png";